const SC_BOT_UA = /googlebot|adsbot|mediapartners|google-inspectiontool|storebot|bingbot|slurp|baiduspider|yandex|duckduckbot|sogou|exabot|facebot|facebookexternalhit|twitterbot|linkedinbot|pinterestbot|whatsapp|telegrambot|discordbot|slackbot|applebot|petalbot|semrushbot|ahrefsbot|mj12bot|dotbot|crawler|spider/i;

class SalesCounter extends HTMLElement {
  connectedCallback() {
    if (this._rendered) return;
    this._rendered = true;

    if (SalesCounter.isBot()) {
      this.remove();
      return;
    }

    const min = parseInt(this.dataset.minCount, 10);
    const max = parseInt(this.dataset.maxCount, 10);
    const productId = this.dataset.productId || 'default';
    const ttlMinutes = parseInt(this.dataset.ttlMinutes, 10);
    const template = this.dataset.textTemplate || '[count]+ BOUGHT IN PAST MONTH';

    const safeMin = Number.isFinite(min) ? min : 5;
    const safeMax = Number.isFinite(max) ? max : 100;
    const safeTtl = Number.isFinite(ttlMinutes) && ttlMinutes > 0 ? ttlMinutes : 20;

    const storageKey = 'embroyce_sales_' + productId;
    let count = SalesCounter.readStorage(storageKey);

    if (!count || !/^\d+$/.test(count)) {
      count = SalesCounter.randomBetween(safeMin, safeMax).toString();
      SalesCounter.writeStorage(storageKey, count, safeTtl);
    }

    const textEl = this.querySelector('[data-sales-counter-text]');
    if (textEl) {
      textEl.textContent = template.replace('[count]', count);
    }

    this.removeAttribute('data-pending');
  }

  static isBot() {
    try {
      return SC_BOT_UA.test(navigator.userAgent || '');
    } catch (e) {
      return false;
    }
  }

  static randomBetween(min, max) {
    const lo = Math.min(min, max);
    const hi = Math.max(min, max);
    return Math.floor(Math.random() * (hi - lo + 1)) + lo;
  }

  static readStorage(key) {
    try {
      const raw = window.localStorage.getItem(key);
      if (!raw) return null;
      const obj = JSON.parse(raw);
      if (!obj || typeof obj.exp !== 'number' || Date.now() > obj.exp) {
        window.localStorage.removeItem(key);
        return null;
      }
      return String(obj.value);
    } catch (e) {
      return null;
    }
  }

  static writeStorage(key, value, ttlMinutes) {
    try {
      const exp = Date.now() + ttlMinutes * 60 * 1000;
      window.localStorage.setItem(key, JSON.stringify({ value: value, exp: exp }));
    } catch (e) {
      /* localStorage unavailable */
    }
  }
}

if (!customElements.get('sales-counter')) {
  customElements.define('sales-counter', SalesCounter);
}
